import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import func, { loadingAction, swalAlert } from "../../services/functions";
import mainAxios from "../../services/mainAxios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartGantt,
  faChevronUp,
  faDownload,
  faFile,
  faFilter,
  faSyncAlt,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Loader from "../Layout/Loader";
import { useAppContext, usePersistedState } from "../../AppContext";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import selectStyle from "../../design/selectStyle";
import DateRange from "../global/DateRange";
import AlertSubscription from "../global/AlertSubscription";
import PrimeTable from "../PrimeTable/PrimeTable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import AlertCertificate from "../global/AlertCertificate";
import AdditionalSaleStatistics from "./AdditionalSaleStatistics";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { globalFilterStatisticCard } from "../global/StatisticsCards";
import CisMessage from "../global/CisMessage";
import { defaultTableRows } from "../../services/data";
import useShowInvoicePdf from "../global/useShowInvoicePdf";
import ExportCsvMultiple from "../global/ExporCsvMultiple";
import useSaleInvoicesExpand from "./components/useSaleInvoicesExpand";
import useGenerateQueueColumns from "./columns/generateQueueColumns";
import { DisableLayout } from "../Layout/DisableLayout";
import { useSaleInvoicesStore } from "../../store/SaleInvocieStore";
import useDownloadInvoices from "../global/useDownloadInvoices";





const moment = require("moment");

const SaleInvoices = () => {
  const { t,i18n } = useTranslation("translations");

  const [uIType, setUIType] = useState({
    value: "eic",
    label: "EIC",
    uidValue: "",
  });

  const [queues, setQueues] = useState(null);
  const [additonalStatsVisible,setAdditonalStatsVisible]=useState(false)
  const [refreshGrid, setRefreshGrid] = useState(false)
  const [filtersCollapsed, setFiltersCollapsed] = usePersistedState(false, "saleInvoicesFiltersCollapsed")
  const [filterDialogVisible, setFilterDialogVisible] = useState(false)

  const defaultExpand = {
    invoiceItems: [],
    expandedRows: null,
    loadingInvoiceItems: false,
    expandedInvoiceRows: [],
    expandedInvoiceData: null,
    loadingInvoiceData: false
  }


  const {
    user: [user],
    selectedCompany: [selectedCompany],
    queueColumns: [queueColumns, setQueueColumns],
    company: [fullCompany],
    dates: [dates, setDates],
    refreshStatuses=[],
  } = useAppContext();


  const {downloadByPeriod,actionCisLoading} = useSaleInvoicesStore()

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );
  const [loading, setLoading] = useState(false);
  const [loadingRefreshStatus, setLoadingRefreshStatus] = useState({
    loading: false,
    index: null,
  });
  const [loadingRequest, setLoadingRequest] = useState(false);

  const refreshAllStatuses = useRef(null);
  const [persistedData, setPersistedData] = usePersistedState(
    null,
    "sessionData"
  );
  const [persistedRowPerPage, setPersistedRowPerPage,] = usePersistedState(
    10,
    "rowsPerPage"
);

  const [statistics, setStatistics] = useState(null);

  const businessUnitCodes = React.useMemo(() => {
    return [
      {
        label: t("invoice.businessUnitCode"),
        value: null,
      },
    ].concat(
      company.branches.map((branch) => {
        return {
          label: branch.businUnitCode + " | " + branch.sellerName,
          value: branch.businUnitCode,
        };
      })
    );
  }, [selectedCompany]);

  const filterParams = {
    businessUnitCode: businessUnitCodes.some(
      (branch) => branch?.value === persistedData?.businessUnitCode
    )
      ? persistedData?.businessUnitCode
      : null,
    operatorCode: null,
    tcrCode: null,
    isEinvoice: null,
    ublId: null,
    correctiveInvoiceType: null,
    ublInvoiceTypeCode: null,
    isForeign: null,
    ublCurrency: [],
    invoiceStatus: [],
    fiscInvoiceType: null,
    ublProfileId: [],
    isOldInvoice: null,
    isDifferentPeriod: null,
    period: null,
    fromCis:null,
    external:"false",


    // checkCisStatus:"false"
  };

  const defaultFilters = useMemo(() => ({
    fromDate: dates.fromDate,
    toDate: dates.toDate,
    params: {
      ...filterParams,
    },
  }), [dates.fromDate, dates.toDate]);

  const [filters, setFilters] = useState(defaultFilters);

  const filterCount = useMemo(() => {
    let count = 0;
    const params = filters?.params;
    if (defaultFilters && params) {
      Object.keys(params).forEach(key => {
        const value = params[key];
        const isDefault = JSON.stringify(value) === JSON.stringify(defaultFilters?.params?.[key]);
        if (!isDefault && value != null) {
          Array.isArray(value) ? count += value.length : count++;
        }
      });
    }
    return count;
  }, [defaultFilters, filters]);

  const tcrList = React.useMemo(() => {
    let buCode = filters?.params?.businessUnitCode;
    let filteredBranch = company.branches.find(
      (branch) => branch.businUnitCode == buCode
    );
    let tcrTypes = filteredBranch?.tcrTypes?.filter(
      (tcrType) => tcrType?.allowInvoice
    );
    let tcrList =
      tcrTypes?.map((tcr) => {
        let sellerName = filteredBranch.sellerName;
        return {
          label: tcr.tcrCode + "-" + sellerName,
          value: tcr.tcrCode,
          inactive: tcr.status < 100
        };
      }) ?? [];

    return tcrList.length > 0
      ? [{ label: "Select", value: null }].concat(tcrList)
      : tcrList;
  }, [selectedCompany, filters?.params?.businessUnitCode]);

  // const handleExportComplete = () => {
  //   setQueuesForCsv([])
  // };

  const userCompanyOperator = user?.userCompanyOperator?.map(
    (userOpCode) => userOpCode.operator
  ) ?? [];

  const cb = company.branches
    .reduce((acc, next) => acc.concat(next.tcrTypes), [])
    .map((tcrType) => tcrType.operatorCode);

  const operatorCodes = [
    {
      label: t("invoice.selectOptions"),
      value: null,
    },
  ].concat(
    [...new Set(userCompanyOperator.concat(cb))].map((operatorCode) => ({
      label: operatorCode,
      value: operatorCode,
    }))
  );


  React.useEffect(() => {
    getFilteredResults(
      {
        data: { ...defaultFilters, params: { ...defaultFilters.params } },
        pageSize: 10,
        page: 1
      });
  }, [selectedCompany,refreshGrid]);

  const [queuesForCsv, setQueuesForCsv] = useState([]);

  const defaultSortCriteria={
    field: "issueDatetime",
    direction: "DESC"
  } 

  const [tableRows, setTableRows] = useState({
    ...defaultTableRows,
    rowsPerPage:persistedRowPerPage,
    sortCriteria:defaultSortCriteria
  });

  const { showInvoicePdf,pdfEmbed,loadingPdf } = useShowInvoicePdf()


  const getFilteredResults = (
    {
      data,
      pageSize = (persistedRowPerPage?? defaultTableRows.rowsPerPage),
      page = defaultTableRows.currentPage,
      clearFilters = false,
      getQueuesForCsv = false,
      refreshSatus,
      setQueueValues = true,
      includePeriod=true,
      sortCriteria = [ defaultSortCriteria ]
    }={}
  ) => {

    const queueData = data
      ? { ...data, params: { ...data.params } }
      : { ...filters, params: { ...filters.params } };
    if (queuesForCsv.length > 0) setQueuesForCsv([]);
    if (refreshSatus) {
      setLoadingRefreshStatus({ loading: true, eic: refreshSatus?.eic });
    }
    else {
      if (setQueueValues) setLoading(true);
    }

    let correctiveInvoiceType = null;
    let ublInvoiceTypeCode = null;

    if (queueData?.params?.correctiveInvoiceType) {
      if (queueData?.params?.correctiveInvoiceType == 380) {
        correctiveInvoiceType = null;
        ublInvoiceTypeCode = queueData.params.correctiveInvoiceType;
      } else {
        correctiveInvoiceType = queueData.params.correctiveInvoiceType;
        ublInvoiceTypeCode = null;
      }
    }
    queueData.params.correctiveInvoiceType = correctiveInvoiceType;
    queueData.params.ublInvoiceTypeCode = ublInvoiceTypeCode;
    if (uIType?.uidValue && !clearFilters) {

      if (uIType?.like == true && ((uIType?.uidValue ?? "").split(",").length == 1)) {
        let val = "<L>" + uIType.uidValue + "<L>";
        queueData.params[uIType.value] = val;
      } else {
        if (uIType.type === "date") {
          queueData.params[uIType.value] = uIType?.uidValue ? moment(uIType.uidValue).format("M/yyyy") : ""
        } else {
          queueData.params[uIType.value] = uIType.uidValue
        }
      }
    }



    let invoiceStatus = queueData.params.invoiceStatus;


    let invStatCorrectedAndSuccessful = ["100,-100", "-100"].every((status) => {
      return invoiceStatus.includes(status);
    });

    if (invStatCorrectedAndSuccessful) {
      invoiceStatus = "-100";
    } else {
      invoiceStatus = invoiceStatus.join(",") || null;
    }

    const params=refreshSatus?.iic ?
    {

      iic: refreshSatus.iic,
    } :
    {
      ...queueData.params,
      ublCurrency: queueData.params.ublCurrency?.join(",") || null,
      ublProfileId: queueData.params.ublProfileId?.join(",") || null,
      invoiceStatus,
      ...(refreshSatus?.eic ? { eic: refreshSatus.eic } : {}),
    }

    // if(!params.toBeVerified){
    //   params.external="false"
    // }
    let requestBody = {
      object: refreshSatus?.action ? "RefreshEinvoiceStatus" : "GetQueueV",
      value: refreshSatus?.value ? refreshSatus?.value : refreshSatus?.action ? refreshSatus?.action : null,
      ...(includePeriod) && { ...queueData },
      params,
      pagination: getQueuesForCsv
        ? null
        : {
          pageSize,
          pageNumber: page,
        },
        sortCriteria
    };

    return mainAxios
      .post(`apiEndpoint/${refreshSatus ? "call" : "search"}`, requestBody)
      .then((res) => {
        refreshSatus
          ? setLoadingRefreshStatus({ loading: false })
          : setLoading(false);
        if (res?.data?.status === true) {
          if (!setQueueValues) return res.data.content;
          if (getQueuesForCsv) {
            setQueuesForCsv(res.data.content);
            return res.data.content;
          } else {
            let content = res.data.content;
            if ((refreshSatus?.eic || refreshSatus?.iic) && content?.length > 0) {
              getFilteredResults({page:tableRows.currentPage,pageSize:tableRows.rowsPerPage})
            } else {
              setQueues(content);
              setTableRows((tableRows)=>({
                ...tableRows,
                totalRows: res?.data?.totalSize,
              }));
            }
          }
          return true;
        } else if(!getQueuesForCsv) {
          if (setQueueValues) setQueues([]);
        }
      })
      .catch((err) => {
        if (setQueueColumns) setLoading(false);
        return null;
      });
  };

  useEffect(() => {
    if (!(filters?.fromDate && filters?.toDate)) {
      return;
    }
    let endpoint = persistedData?.businessUnitCode
      ? "/endpoint/v2/reports/queue/branch/aggregate"
      : "/endpoint/v2/reports/queue/company/aggregate";
    mainAxios
      .post(endpoint, {
        object: "GetQueueCashDepositStatisticsAnalytics",
        fromDate: moment(filters?.fromDate).format("YYYY-MM-DD"),
        toDate: moment(filters?.toDate).format("YYYY-MM-DD"),
        ...(filters?.params?.businessUnitCode
          ? { params: { businessUnitCode: filters?.params?.businessUnitCode } }
          : {}),
      })
      .then((res) => {
        if (res?.data?.status) {
          let getStatistics = calculateStatistics(res.data.content);
          setStatistics(getStatistics);
        }
      });
  }, [
    filters?.fromDate,
    filters?.toDate,
    filters?.params?.businessUnitCode,
    selectedCompany,
  ]);



  const calculateStatistics = (data) => {
    if (data?.length > 0) {
      const { id, tcrCode, businessUnitCode, actionFrom, company, ...rest } =
        data[0];
      let stats = {};
      Object.keys(rest).forEach((key) => {
        stats[key] = data.reduce((sum, tcrStat) => sum + tcrStat[key], 0);
      });
      return stats;
    }
    return [];
  };

  const resendQueue = (e, queue) => {
    e.preventDefault();

    Swal.fire({
      title: t(["notification.resendInvoice"]),
      confirmButtonText: t(["company.yes"]),
      showCancelButton: true,
      cancelButtonText: t(["company.no"]),
    }).then((res) => {
      if (res.isConfirmed) {
        setLoadingRequest(true);
        mainAxios
          .post("apiEndpoint/call", {
            object: "ResendInvoice",
            value: null,
            params: {
              // ublId: queue.ublId + "",
              iic: queue?.iic,
            },
          })
          .then((res) => {
            if (res?.data?.status === true) {
              let foundQueue = -1;
              queues.forEach((stateQueue, index) => {
                if (stateQueue === queue) foundQueue = index;
              });
              

              let newQueues = [...queues];
              newQueues[foundQueue].fiscStatus = 100;
              newQueues[foundQueue].einvoiceStatus = 100;
              setQueues(newQueues);
              toast.success(t(["notification.success"]), {
                containerId: "all_toast",
              });
            }
            setLoadingRequest(false);
          });
      }
    });
  };

  const cancelSuccessQueue = (e, queue) => {
    e.preventDefault();

    let params = {
      iic: queue.iic + "",
      fiscStatus: queue.fiscStatus + "",
    };

    if (queue.einvoiceStatus)
      params = { ...params, einvoiceStatus: queue.einvoiceStatus + "" };

    Swal.fire({
      title: t(["notification.cancel"]),
      confirmButtonText: t(["company.yes"]),
      showCancelButton: true,
      cancelButtonText: t(["company.no"]),
    }).then((res) => {
      if (res.isConfirmed) {
        loadingAction({func:()=>{
          setLoadingRequest(true);
          return mainAxios
          .post("apiEndpoint/call", {
            object: "SendCorrectiveEinvoice",
            params,
          })
          .then((res) => {
            if (res?.data?.status === true) {
              getFilteredResults();
              toast.success(t(["notification.cancelled"]), {
                containerId: "all_toast",
              });
            }
            setLoadingRequest(false);
          })
          .catch(err=>{
            setLoadingRequest(false);
          })
        },message:t("common.invoiceCancelling")})
        setLoadingRequest(true);

      }
    });
  };

  const cancelQueue = (e, queue) => {
    e.preventDefault();
    Swal.fire({
      title: t(["notification.cancel"]),
      confirmButtonText: t(["company.yes"]),
      confirmButtonColor: "#d33",
      cancelButtonColor: "#007567",
      showCancelButton: true,
      cancelButtonText: t(["company.no"]),
    }).then((res) => {
      if (res.isConfirmed) {
        loadingAction({func:()=>{
          setLoadingRequest(true);
          return mainAxios
          .post("apiEndpoint/call", {
            object: "CancelInvoiceRequest",
            value: null,
            params: {
              iic: queue.iic + "",
              fiscStatus: queue.fiscStatus + "",
            },
          })
          .then((res) => {
            if (res?.data?.status === true) {
              getFilteredResults();
              toast.success(t(["notification.cancelled"]), {
                containerId: "all_toast",
              });
            }
            setLoadingRequest(false);
          })
          .catch(err=>{
            setLoadingRequest(false);
          })
        },message:"Please wait,invoice is being cancelled..."})
        setLoadingRequest(true);

      }
    });
  };


  const verifyInvoices = (e, queue) => {
    e.preventDefault();
    loadingAction({
      func: () => {
        setLoadingRequest(true);
        return mainAxios
        .post("endpoint/v2.2/saveOrUpdate", {
            object: "VerifyInvoice",  
            nuis: fullCompany.nuis,
            content: {
              iic: queue.iic + "",
            },
          })
          .then((res) => {
            if (res?.data?.status === true) {
              getFilteredResults();
              toast.success(t(["notification.verifyInvoice"]), {
                containerId: "all_toast",
              });
            }
            setLoadingRequest(false);
          })
          .catch((err) => {
            setLoadingRequest(false);
            console.error("Error verifying the invoice:", err);
          });
      },
      message: "Please wait, invoice is being verified...",
    });
    setLoadingRequest(true);
  };
  

  const handleParamsChange = (e, label, val) => {
    const key = e ? e.target.name : label;
    const value = e ? e.target.value : val;
    setFilters((filters) => ({
      ...filters,
      params: {
        ...filters.params,
        [key]: value,
      },
    }));
  };

  const refreshStatusesActiveList = useMemo(()=>{
    return refreshStatuses?.filter(resendStatus=>resendStatus?.isActive==true)?.map(resendStatus=>resendStatus?.status)?? []
},[refreshStatuses])

const pendingEinvoiceStatuses = useMemo(() =>
  refreshStatuses?.filter(s => s.type === "einvoice" && s.isActive)
    ?.map(s => s.status) ?? []
, [refreshStatuses])

let isRefreshStatus=useCallback((invoice)=>{
  let staticRefreshConditions=(invoice?.einvoice && invoice?.cisStatus==="SUCCESS" && (!invoice?.eic || invoice.eic=="")) || invoice?.cisStatus =="PENDING"
  return (refreshStatusesActiveList.includes(invoice?.fiscStatus?.toString())) || staticRefreshConditions
},[refreshStatuses])


  let columns = useGenerateQueueColumns(
    {
      resendQueue,
      cancelQueue,
      cancelSuccessQueue,
      queueColumns,
      loadingRequest,
      t,
      loadingPdf,
      showInvoicePdf,
      getFilteredResults,
      tableRows,
      loadingRefreshStatus,
      operatorCodes,
      handleParamsChange,
      filters,
      fullCompany,
      user,
      i18n,
      verifyInvoices,
      isRefreshStatus,
      pendingEinvoiceStatuses
    }
  );



  const [selectedColumns, setSelectedColumns] = usePersistedState(
    columns.map((col) => ({field:col.field,show:!!col.default,...(col?.persisted?{persisted:true}:{})})),
    "queueColumnsPrime7"
  );

  const { expanded,expansionColumn, onRowExpand,onRowCollapse, rowExpansionTemplate } = useSaleInvoicesExpand({
    getFilteredResults, columns, selectedColumns, setSelectedColumns,defaultFilters
  });


  const typeOptions = [
    {
      key: "isEinvoice",
      label: t("invoice.eInvoicesOption"),
      value: "true",
      count: statistics?.einvoicesNo,
    },
    {
      key: "isEinvoice",
      label: t("parameters.onlyFiscalization"),
      value: "false",
      count: statistics?.fiscalizatedInvoicesNo,
    },
  ];

  const sourceOptions = [

    {
      key: "isApiSource",
      label: "API",
      value: "true",
      count: statistics?.apiSourceNo,
    },

    {
      key: "isApiSource",
      label: t("common.manual"),
      value: "false",
      count: statistics?.manualInvoiceSourceNo,
    },
    {
      key: "toBeVerified",
      label: t("queue.toBeVerified"),
      value: "true",
      count: statistics?.toBeVerified,
      roundPillStyle: statistics?.toBeVerified>0?"to-verify-roundpill":null
    },
    // {
    //   key: "fromCis",
    //   label: t("queue.fromSelfCare"),
    //   value: "false",
    //   count: statistics?.manualInvoiceSourceNo,
    // },


  ]

  const refreshAllCisStatusesFilter=useMemo(()=>{
    const filteredStatuses=refreshStatusesActiveList.filter(status=>func.isNumeric(status)) ?? []
    return filteredStatuses.join(",")
  },[refreshStatusesActiveList])

  const statusOptions = [
    // {
    //   key:"invoiceStatus",
    //   label: "All Statuses",
    //   value: "-1,100,-100",
    //   count: statistics?.errorInvoicesNo + statistics?.successInvoicesNo
    // },

    {
      key: "invoiceStatus",
      label: t("status.successful"),
      multiSelect: true,
      value: "100,-100",
      count: statistics?.successInvoicesNo,
    },
    {
      key: "invoiceStatus",
      label: "Error",
      multiSelect: true,
      value: "-2",
      count: statistics?.errorInvoicesNo,
    },
    {
      key: "invoiceStatus",
      label: "Pending",
      multiSelect: true,
      value: refreshAllCisStatusesFilter,
      count: statistics?.pendingInvoicesNo,
    },
  ];

  const otherOptions = [
    {
      key: "ublProfileId",
      multiSelect: true,
      count: statistics?.selfInvoicesNo,
      label: t("invoice.selfInvoice"),
      value: "P12",
    },
    {
      key: "ublProfileId",
      multiSelect: true,
      count:
        (statistics?.noncashCorrectiveNo ?? 0) +
        (statistics?.cashCorrectiveNo ?? 0),
      label: t("invoice.corrective"),
      value: "P10",
    },
    {
      key: "fiscInvoiceType",
      count: statistics?.cashInvoicesNo,
      label: "Cash",
      value: "cash",
    },
    {
      key: "isForeign",
      count: statistics?.foreignInvoicesNo,
      label: t("common.foreign"),
      value: "true",
    },
    {
      key: "isSubseq",
      count: statistics?.subseqInvoicesNo,
      label: "Subseq",
      value: "true",
    },
    {
      key: "invoiceStatus",
      multiSelect: true,
      count: statistics?.correctedInvoicesNo,
      label: t("status.corrected"),
      value: "-100",
    },
    {
      key: "isOldInvoice",
      count: statistics?.oldInvoicesNo,
      label: t("queue.oldInvoice"),
      value: "true",
    },
    {
      key: "isReverseCharge",
      count: statistics?.isReverseCharge,
      label: t("home.reverseCharge"),
      value: "true",
    },
    {
      key: "isSummaryInv",
      count: statistics?.isSummaryInvoice,
      label:t("invoice.summaryInvoiceFilter"),
      value: "true",

    },

  ];

  const currencyOptions = [
    {
      key: "ublCurrency",
      count: statistics?.allCurrencyInvoicesNo,
      multiSelect: true,
      label: "Lek",
      value: "ALL",
    },
    {
      key: "ublCurrency",
      count: statistics?.usdCurrencyInvoicesNo,
      multiSelect: true,
      label: "USD",
      value: "USD",
    },
    {
      key: "ublCurrency",
      count: statistics?.eurCurrencyInvoicesNo,
      multiSelect: true,
      label: "Euro",
      value: "EUR",
    },
  ];

  const filterStatisticCard=(typeOptions,props)=>globalFilterStatisticCard(typeOptions,{...props,handleParamsChange,getFilteredResults,user,filters})

  const downloadByPeriodButton = ( <div>
        <button
          className="btn btn-sm btn-primary rounded-pill ml-2"
          disabled={actionCisLoading}
          onClick={(e) => {
              downloadByPeriod({filters,onSuccess:()=>{
                setRefreshGrid(value=>!value)
              }});
          }}
        >
          <FontAwesomeIcon  icon={faFile} className="mr-2" />
          {t("purchases.downloadByPeriod")}
        </button>
    </div>)


  const headerButtonsLeft = (
    <div className="d-flex justify-content-center align-items-center">
      <div style={{ width: 200, marginRight: 20 }}>
        <Select
          // style={{width:"100%"}}
          placeholder={"TCR Code"}
          styles={selectStyle}
          options={tcrList}
          isSearchable={true}
          value={
            tcrList.find(
              (option) => option.value === filters.params?.tcrCode
            ) ?? ""
          }
          onChange={(tcrCode) => {
            getFilteredResults({
              data: {
                ...filters,
                params: { ...filters.params, "tcrCode": tcrCode.value },
              }
            });
            handleParamsChange(null, "tcrCode", tcrCode.value)
          }}
          name="tcrCode"
        />
      </div>
      <div
        style={{ width: 180 }}
        className={`btn btn-sm btn-outline-primary rounded-pill ${loadingRefreshStatus?.loading ? "disabled" : ""
          }`}
        disabled={loadingRefreshStatus?.loading}
        onClick={(e) => {
          if(user?.role?.id==1){ //sysAdmin
            refreshAllStatuses.current.toggle(e)
          }else {
            refreshCisStatus()

          }
        }}
      >
        <FontAwesomeIcon icon={faSyncAlt} className="mr-2" />
        {t("purchases.refreshAllCis")}
      </div>
      {[1,2].includes(user?.role?.id) && fullCompany?.companyAttributes?.find(a => a?.attribute?.param === "manualWs")?.value !== "no" && downloadByPeriodButton}
      {/* <div
        style={{ width: 180 }}
        className={`btn btn-sm btn-outline-info rounded-pill ml-2`}
        onClick={(e) =>setAdditonalStatsVisible(true)}
      >
      <FontAwesomeIcon icon={faChartGantt} className="mr-2"/>        
          Additional Statistics
      </div>  */}

    </div>
  )






  const refreshAllCisStatuses=()=>{
    mainAxios.post("/apiEndpoint/async/call",{
      object: "RefreshEinvoiceStatus" ,
      refreshSatus: { action: "UpdateAll" },
      value: "UpdateAll",
      params:{},
      pagination: {
        pageSize:10,
        pageNumber: 1,
      }
    })
    .then(res=>{
      if(res.data.status){
        toast.success(res.data.message, {
          containerId: "all_toast",
        })
      }
    })
  }

  const refreshAllStatusesModel=()=>{
    return [
      {
      label: t("queue.refreshAllCisStatuses"),
      command:async () => {
        const res = await swalAlert({ title: t("queue.refreshAllCisStatuses"),text: t("queue.refreshAllStatuses"),t})
        if (res) refreshAllCisStatuses()
      },
      disabled: loadingRefreshStatus?.loading
    },
    {
      label: t("queue.refreshAllCisStatusesPeriod"),
      command: () => {
        refreshCisStatus()
       },
      disabled: loadingRefreshStatus?.loading
    }

  ]
  }

  const refreshCisStatus=({includePeriod=true}={})=>{
    getFilteredResults({
      page: tableRows.currentPage,
      refreshSatus: { action: "UpdateAll"},
      includePeriod
    });
  }

  const model = refreshAllStatusesModel()

  // Function to fetch all invoice IDs from backend (without pagination)
  // Multiselect download functionality using reusable hook
  const {
    downloadCheckboxBody: multiselectCheckboxBody,
    downloadMultiFilter: multiselectCheckboxFilter,
    downloadButtonsRight: headerButtonsRight,
    selectedRows: selectedDownloadRows,
    setSelectedRows: setSelectedDownloadRows,
    downloadLoading,
  } = useDownloadInvoices({
    getBodyPayload: (selectedRows) => {
      // Convert selected rows to array of IDs (numbers)
      const selectedIds = (selectedRows || []).map((s) => s?.id);
      return {
        object: 'SalePDFs',
        fromDate: filters.fromDate,
        toDate: filters.toDate,
        ids: selectedIds,
        params: {
          dataFrom: "DB",
          search: "einvoice",
          ...filters.params
        },
        nuis: fullCompany.nuis,
        username: user.username,
        company: selectedCompany
      };
    },
    filterInvoices: (invoice) => {
      const einvoice = invoice?.einvoice;
      const fic = invoice?.fic;
      const eic = invoice?.eic;
      const invoiceStatus = invoice?.invoiceStatus;

      // Check if invoiceStatus is 100 or -100
      const hasValidStatus = invoiceStatus === 100 || invoiceStatus === -100;

      // Original condition AND new status condition
      return ((!einvoice && fic) || (einvoice && eic)) && hasValidStatus;
    },
  });

  // Clear selected rows when filters change (but not when navigating between pages)
  useEffect(() => {
    if (selectedDownloadRows.length > 0) {
      setSelectedDownloadRows([]);
    }
  }, [filters.fromDate, filters.toDate]);

  // Export dropdown for headerIcons
  const exportDropdown = (
    <ExportCsvMultiple
      data={queuesForCsv}
      selectedColumns={selectedColumns}
      columns={columns}
      onClick={() => getFilteredResults({ getQueuesForCsv: true })}
      excludedColumns={["status", "actions", "print"]}
      callback={(invoice, formattedObject) => {
        formattedObject["Fisc Status"] = invoice.fiscStatus;
        formattedObject["Einvoice Status"] =
          invoice.einvoiceStatus || "";
        formattedObject["Is Einvoice"] = invoice.einvoice
          ? "TRUE"
          : "FALSE";
      }}
      asDropdown={true}
    />
  );

  return queues ? (
    <>
      {user?.role?.id == 1 && <Menu model={model} popup ref={refreshAllStatuses} />}
      <div className="d-flex flex-wrap justify-content-between align-items-center my-1">
        <div className="left-header d-flex align-items-center">
          <h3 className="mb-0 p-0">{t("navbar.fiscalizedInv")}</h3>
          <AlertCertificate />
          <AlertSubscription />
        </div>
        <CisMessage transactionType="sales" />
        <Dialog
          header="Additional Statistics"
          visible={additonalStatsVisible}
          onHide={() => setAdditonalStatsVisible(false)}
          breakpoints={{ "960px": "85vw", "641px": "100vw" }}
          className="container mx-auto"
          style={{zIndex:100}}
        >
          <AdditionalSaleStatistics />
        </Dialog>
        <div className="d-flex align-items-center ml-auto">
          <div className="mr-2">
            <DateRange
              fromDate={filters.fromDate}
              toDate={filters.toDate}
              onChange={(dates) => {
                let fromDate = dates[0];
                let toDate = dates[1];
                if (fromDate && toDate) {
                  getFilteredResults({
                    data: {
                      ...filters,
                      fromDate,
                      toDate,
                      params: { ...filters.params },
                    }
                  });
                }
                setFilters((filters) => ({
                  ...defaultFilters,
                  fromDate,
                  toDate,
                }));
                setDates({ fromDate, toDate })
              }}
            />
          </div>
          <div className="d-flex align-items-center" style={{minWidth: "140px"}}>
            <label className="align-items-center mr-2 mb-0">BU</label>
            <Select
              styles={selectStyle}
              className="w-100"
              options={businessUnitCodes}
              value={
                filters.params?.businessUnitCode
                  ? businessUnitCodes.find(
                    (option) =>
                      option.value === filters.params?.businessUnitCode
                  )
                  : { label: t("invoice.businessUnitCode"), value: "" }
              }
              isSearchable={true}
              onChange={(businessUnitCode) => {
                handleParamsChange(
                  null,
                  "businessUnitCode",
                  businessUnitCode.value
                );
                setPersistedData({
                  ...persistedData,
                  businessUnitCode: businessUnitCode.value,
                });
                getFilteredResults({
                  data: {
                    ...filters,
                    params: {
                      ...filters.params,
                      businessUnitCode: businessUnitCode.value,
                    },
                  }
                });
              }}
              name="businessUnitCode"
            />
          </div>
        </div>
      </div>
      <div className="filter-cards-container d-none d-md-block">
        <div className="filter-cards-header">
          <button
            className={`filter-cards-toggle ${filtersCollapsed ? 'filter-cards-toggle--collapsed' : ''}`}
            onClick={() => setFiltersCollapsed(!filtersCollapsed)}
          >
            <FontAwesomeIcon icon={faFilter} />
            {filtersCollapsed ? (t("common.showFilters", "Show Filters")) : (t("common.hideFilters", "Hide Filters"))}
            {filterCount > 0 && <span className="badge badge-primary ml-1">{filterCount}</span>}
            <FontAwesomeIcon icon={faChevronUp} />
          </button>
        </div>
        <div className={`filter-cards-row ${filtersCollapsed ? 'filter-cards-row--collapsed' : ''}`}>
          <div className="filter-card-col">
            {filterStatisticCard(typeOptions, {
              title: t("home.invoiceType"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col">
            {filterStatisticCard(statusOptions, {
              title: t("home.status"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col">
            {filterStatisticCard(sourceOptions, {
              title: t("common.source"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col">
            {filterStatisticCard(currencyOptions, {
              title: t("invoice.currency"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col filter-card-col--wide">
            {filterStatisticCard(otherOptions, {
              title: t("invoice.other"),
              cardClasses: "stats-cols-3",
              type: "checkbox",
            })}
          </div>
        </div>
      </div>
      <Dialog
        header={t("common.filters", "Filters")}
        visible={filterDialogVisible}
        onHide={() => setFilterDialogVisible(false)}
        breakpoints={{ "960px": "85vw", "641px": "100vw" }}
        style={{ width: "95vw" }}
        footer={
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => {
              getFilteredResults({
                data: { ...filters, params: { ...defaultFilters.params } },
              });
              setFilterDialogVisible(false);
            }}
          >
            {t("queue.clearFilters", "Clear Filters")}
          </button>
        }
      >
        <div className="filter-cards-row">
          <div className="filter-card-col">
            {filterStatisticCard(typeOptions, {
              title: t("home.invoiceType"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col">
            {filterStatisticCard(statusOptions, {
              title: t("home.status"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col">
            {filterStatisticCard(sourceOptions, {
              title: t("common.source"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col">
            {filterStatisticCard(currencyOptions, {
              title: t("invoice.currency"),
              cardClasses: "stats-cols-1",
            })}
          </div>
          <div className="filter-card-col filter-card-col--wide">
            {filterStatisticCard(otherOptions, {
              title: t("invoice.other"),
              cardClasses: "stats-cols-3",
              type: "checkbox",
            })}
          </div>
        </div>
      </Dialog>
      <div>
            <PrimeTable
              showFilters={true}
              filters={[filters, setFilters]}
              defaultFilters={defaultFilters}
              tableRows={[tableRows, setTableRows]}
              persistedRowPerPage={[persistedRowPerPage, setPersistedRowPerPage]}
              value={queues}
              gridKey="queueColumnsPrime7"
              selectedColumns={[selectedColumns, setSelectedColumns]}
              searchableKeys={["buyerName", "ublCustomerCityName", "buyerNuis"]}
              columns={columns}
              expandedRows={expanded.expandedRows}
              moveToTopColumns={false}
              onRowExpand={onRowExpand}
              onRowCollapse={onRowCollapse}
              rowExpansionTemplate={rowExpansionTemplate}
              reorderableColumns={true}
              dataKey="ublId"
              onRemoteDataChange={(remoteData) => {
                const updatedFilters = remoteData.filters ?? filters
                const updatedTableData = remoteData.tableRows ?? tableRows
                let { currentPage, rowsPerPage, sortCriteria } = updatedTableData
                sortCriteria=sortCriteria?[sortCriteria]:[]
                getFilteredResults({ data: updatedFilters, pageSize: rowsPerPage, page: currentPage, sortCriteria })
              }}
              onClearFilter={() => {
                setSelectedDownloadRows([]);
              }}
              headerButtonsLeft={headerButtonsLeft}
              headerButtonsRight={headerButtonsRight}
              headerIcons={exportDropdown}
              columnDeps={[expanded, fullCompany,loadingRequest,tableRows,loadingPdf]}
              loading={loading || downloadLoading}
              defaultSortCriteria={defaultSortCriteria}
              mobileSelectionBody={multiselectCheckboxBody}
              mobileExpansionLabel={t("invoice.invoiceItems", "Invoice Items")}
              mobileFilterContent={
                <div className="filter-cards-row">
                  <div className="filter-card-col">
                    {filterStatisticCard(typeOptions, {
                      title: t("home.invoiceType"),
                      cardClasses: "stats-cols-1",
                    })}
                  </div>
                  <div className="filter-card-col">
                    {filterStatisticCard(statusOptions, {
                      title: t("home.status"),
                      cardClasses: "stats-cols-1",
                    })}
                  </div>
                  <div className="filter-card-col">
                    {filterStatisticCard(sourceOptions, {
                      title: t("common.source"),
                      cardClasses: "stats-cols-1",
                    })}
                  </div>
                  <div className="filter-card-col">
                    {filterStatisticCard(currencyOptions, {
                      title: t("invoice.currency"),
                      cardClasses: "stats-cols-1",
                    })}
                  </div>
                  <div className="filter-card-col filter-card-col--wide">
                    {filterStatisticCard(otherOptions, {
                      title: t("invoice.other"),
                      cardClasses: "stats-cols-3",
                      type: "checkbox",
                    })}
                  </div>
                </div>
              }
            >
              <Column
                filter={true}
                header=""
                showFilterMenu={false}
                showClearButton={false}
                filterElement={() => multiselectCheckboxFilter(queues)}
                body={multiselectCheckboxBody}
                headerStyle={{ minWidth:"50px",maxWidth:"50px", padding:"0",paddingLeft:"5px" }}
                frozen
              />
              {expansionColumn}
            </PrimeTable>
          {pdfEmbed}
      </div>
    </>
  ) : (
    <Loader />
  );
};

export default SaleInvoices;
